import TextHighlighter from 'marketing/utils/TextHighlighter';
import { trackEvent } from '@99designs/utils/platform';
import { replaceKeys } from 'marketing/utils/internationalisation-utils';

export default class CategorySearch {
    constructor(searchBox, resultsCounter, resultsElement, searcher) {
        this.searchBox = searchBox;
        this.resultsCounter = resultsCounter;
        this.resultsElement = resultsElement;
        this.highlighter = new TextHighlighter;
        this.searcher = searcher;
        this.trackTimeout = null;
        this.trackSearch = this.trackSearch.bind(this);

        searchBox.addEventListener('keyup', this.search.bind(this));
    }

    updateResultsCounter(results, searchTerm) {
        const msgString = results.length > 1 ? window.categoriesLang.resultsCountPlural : window.categoriesLang.resultsCountSingular;


        this.resultsCounter.innerHTML = replaceKeys(msgString, {
            count: results.length,
            searchTerm: `<span class="highlighted-term">${this.escape(searchTerm)}</span>`
        });
    }

    escape(string) {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(string));
        return div.innerHTML;
    }

    highlightMatches(result, matchingTerms) {
        const titleNode = result.node.querySelector('[data-category-title]');
        const parentTitleNode = result.node.querySelector('[data-category-parent-title]');

        // reset highlighting
        titleNode.innerHTML = result.title;
        parentTitleNode.innerHTML = result.parent;

        // highlight
        titleNode.innerHTML = this.highlighter.highlight(result.title, matchingTerms, 'highlighted-term');
        parentTitleNode.innerHTML = this.highlighter.highlight(result.parent, matchingTerms, 'highlighted-term');

        return result.node;
    }

    updateResults(results, matchingTerms) {
        this.resultsElement.textContent = '';

        results.forEach((result) => {
            this.resultsElement.appendChild(this.highlightMatches(result, matchingTerms));
        });
    }

    search() {
        const searchTerm = this.searchBox.value;
        const searchResult = this.searcher.search(searchTerm);

        this.updateResultsCounter(searchResult.results, searchTerm);
        this.updateResults(searchResult.results, searchResult.matchingTerms);

        this.trackSearch(searchResult.results);
    }

    trackSearch(results) {
        if (this.trackTimeout) {
            clearTimeout(this.trackTimeout);
        }

        this.trackTimeout = setTimeout(() => {
            if (this.searchBox.value) {
                trackEvent('Performed Search On Categories Page', {
                    searchTerm: this.searchBox.value,
                    noOfSearchResults: results.length
                });
            }
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/CategorySearch.js